import { convertDate } from ".";

const utcDate = (dateTime: string) =>
  new Date(convertDate(dateTime, "MMMM DD YYYY HH:mm")).toUTCString();

export default utcDate;
